import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns, TableDefaultFetchValues } from '../../configuration';
import * as CentralBankPaymentSelectors from '../../../../redux/reducers/payment_central_bank_reducer/selectors';
import { useDispatch } from 'react-redux';
import CentralBankPaymentActions from '../../../../redux/reducers/payment_central_bank_reducer/actions';
import { Box } from '@material-ui/core';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';
import NavigationConfig from 'navigation/config';
import { useHistory } from 'react-router';
import { parseQueryDate } from '../../../../utils/dates';

export default function DatatableList() {
  const ROLE = AuthSelectors.useSelectUserRole();
  const result = CentralBankPaymentSelectors.useGetCentralBankPaymentList();
  const dispatch = useDispatch();

  const query = useQuery();
  const sortField: string = query.get('sortField')
    ? (query.get('sortField') as string)
    : TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const order: 'asc' | 'desc' = query.get('order')
    ? (query.get('order') as 'asc' | 'desc')
    : TableDefaultFetchValues.TABLE_DEFAULT_ORDER;
  const account = query.get('account');
  const statusCode = query.get('statusCode');
  const dateFrom = query.get('dateFrom');
  const dateTo = query.get('dateTo');
  interface Paging {
    page: number;
    pageSize: number;
    total: number;
  }

  const paging: Paging = {
    pageSize: result.data
      ? result.data.paging.pageSize
      : TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
    page: result.data
      ? result.data.paging.page
      : TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
    total: result.data ? result.data.paging.total : 0,
  };

  const history = useHistory();

  return (
    <Box display="flex" flexDirection="column">
      {ROLE === AuthRoles.Admin && (
        <Filter
          statusCode={statusCode}
          account={account}
          dateFrom={parseQueryDate(dateFrom)}
          dateTo={parseQueryDate(dateTo)}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField,
          order: order,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(_selectedPage, _pageSize, _order, _sortField) => {
          let query = [];
          if (statusCode)
            query.push({
              key: 'statusCode',
              value: statusCode,
            });
          if (account)
            query.push({
              key: 'account',
              value: account,
            });
          if (dateFrom)
            query.push({
              key: 'dateFrom',
              value: dateFrom,
            });
          if (dateTo)
            query.push({
              key: 'dateTo',
              value: dateTo,
            });
          let queryString = `?sortField=${_sortField}&page=${_selectedPage}&pageSize=${_pageSize}&order=${_order}`;
          query.map((query, index) => {
            queryString += `&${query.key}=${query.value}`;
          });
          dispatch(
            CentralBankPaymentActions.setCentralBankPaymentsAction({
              sortField: _sortField,
              page: _selectedPage,
              pageSize: _pageSize,
              order: _order,
              account: account,
              statusCode: statusCode,
              dateFrom: dateFrom,
              dateTo: dateTo,
            })
          );
          history.push(
            NavigationConfig.paymentCentralBankPage().path + queryString
          );
        }}
      />
    </Box>
  );
}
